import React from "react";
import { Row, Col } from "react-bootstrap";
import "./product.css";
import "./home.css";
const Product = ({ selectedId, selectedTitle, selectedText, selectedImg }) => {
  return (
    <>
      <div
        className="recorners"
        style={{ marginBottom: "30px", marginTop: "20px" }}
      >
        <Row>
          <Col lg={4} xs={12}>
            <img
              src={selectedImg}
              alt="img"
              style={{ width: "200px", textAlign: "center" }}
            />
          </Col>
          <Col lg={8} xs={12}>
            <div
              style={{
                textAlign: "center",
                paddingTop: "48px",
                color: "black",
                fontWeight: "bold",
                fontSize: "30px",
              }}
            >
              {selectedTitle}
            </div>
          </Col>
        </Row>
        <Row className="product_detail">{selectedText}</Row>
      </div>
    </>
  );
};

export default Product;
